import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
export function Base(_ref) {
  var inline = _ref.inline,
      component = _ref.component,
      className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["inline", "component", "className", "style", "children"]);

  var _component = component || (props.href ? 'a' : inline ? 'span' : 'div');

  return React.createElement(_component, _objectSpread({
    style: style,
    className: className
  }, props), children);
}

function makeTextComponent() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var component = arguments.length > 1 ? arguments[1] : undefined;
  return function (_ref2) {
    var children = _ref2.children,
        className = _ref2.className,
        props = _objectWithoutProperties(_ref2, ["children", "className"]);

    return React.createElement(Base, Object.assign({
      className: classNames(classes, className),
      component: component
    }, props), children);
  };
}

export var Title = makeTextComponent('shade-05 font-size-largest font-family-title font-weight-medium', 'h1');
export var Subtitle = makeTextComponent('shade-05 font-size-larger font-family-title font-weight-regular', 'h2');
export var Corpus = makeTextComponent('shade-10 font-size-large font-family-system line-height-larger font-weight-regular');
export var EditorCorpus = makeTextComponent('shade-05 font-size-large font-family-system font-weight-regular');
export var Section = makeTextComponent('shade-05 font-size-large font-family-system font-weight-bold');
export var Name = makeTextComponent('shade-05 font-size-normal font-family-system font-weight-bold');
export var Detail = makeTextComponent('shade-20 font-size-small font-family-system font-weight-regular');
export var SmallDetail = makeTextComponent('shade-20 font-size-smaller font-family-system font-weight-regular');
export var Action = makeTextComponent('pointer blue-dark font-size-smaller font-family-system font-weight-medium');
export var PrimaryAction = makeTextComponent('pointer primary primary-dark-on-hover font-size-normal font-family-system font-weight-medium');
export default {
  Title: Title,
  Subtitle: Subtitle,
  Corpus: Corpus,
  EditorCorpus: EditorCorpus,
  Section: Section,
  Name: Name,
  Detail: Detail,
  SmallDetail: SmallDetail,
  Action: Action,
  PrimaryAction: PrimaryAction
};